<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card class="mgb20" shadow="hover" style="height:252px;">
                    <div class="user-info">
                        <img alt class="user-avator" src="../../assets/img/avatar_female.jpg"/>
                        <div class="user-info-cont">
                            <div class="user-info-name">{{user.Usn}}</div>
                            <div>{{role}}-{{user.Uname}}</div>
                        </div>
                    </div>
                    <div class="user-info-list">
                        上次登录时间：
                        <span>{{user.Ulast_time}}</span>
                    </div>
                    <div class="user-info-list">
                        上次登录地点：
                        <span>{{user.Ulast_ip}}</span>
                    </div>
                </el-card>
                <el-card shadow="hover" style="height:252px;">
                    <div class="clearfix" slot="header">
                        <span>本月目标</span>
                    </div>
                    试用会员
                    <el-progress :percentage="71.3" color="#42b983"></el-progress>
                    付费会员
                    <el-progress :percentage="24.1" color="#f1e05a"></el-progress>
                    行程报价
                    <el-progress :percentage="13.7"></el-progress>
                    <!--                    公司客户<el-progress :percentage="5.9" color="#f56c6c"></el-progress>-->
                </el-card>
            </el-col>
            <el-col :span="16">
                <el-row :gutter="20" class="mgb20">
                    <el-col :span="8">
                        <el-card :body-style="{padding: '0px'}" shadow="hover">
                            <div class="grid-content grid-con-1">
                                <i class="el-icon-lx-people grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{pageData.daikaifa}}</div>
                                    <div>待开发的客户</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card :body-style="{padding: '0px'}" shadow="hover">
                            <div class="grid-content grid-con-2">
                                <i class="el-icon-lx-crown grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{pageData.yihezuo}}</div>
                                    <div>合作过的客户</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card :body-style="{padding: '0px'}" shadow="hover">
                            <div class="grid-content grid-con-3">
                                <i class="el-icon-lx-calendar grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{pageData.zanfangqi}}</div>
                                    <div>暂放弃的客户</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-card shadow="hover" style="height:403px;">
                    <div class="clearfix" slot="header">
                        <span>待办事项</span>
                        <el-button style="float: right; padding: 3px 0" type="text">添加</el-button>
                    </div>
                    <el-table :data="todoList" :show-header="false" style="width:100%;">
                        <el-table-column width="40">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.status"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <div
                                        :class="{'todo-item-del': scope.row.status}"
                                        class="todo-item"
                                >{{scope.row.title}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="60">
                            <template>
                                <i class="el-icon-edit"></i>
                                <i class="el-icon-delete"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card shadow="hover">
                    <schart :options="options" canvasId="bar" class="schart" ref="bar"></schart>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card shadow="hover">
                    <schart :options="options2" canvasId="line" class="schart" ref="line"></schart>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Schart from 'vue-schart';

    export default {
        name: 'dashboard',
        data() {
            return {
                pageData: {
                    yihezuo: 0,
                    daikaifa: 0,
                    zanfangqi: 0
                },
                name: sessionStorage.getItem('yp_username'),
                uid: { userId: sessionStorage.getItem('yp_userid') },
                user: [],
                todoList: [
                    {
                        title: '今天要修复100个bug',
                        status: false
                    },
                    {
                        title: '今天要修复100个bug',
                        status: false
                    },
                    {
                        title: '今天要写100行代码加几个bug吧',
                        status: false
                    },
                    {
                        title: '今天要修复100个bug',
                        status: false
                    },
                    {
                        title: '今天要修复100个bug',
                        status: true
                    },
                    {
                        title: '今天要写100行代码加几个bug吧',
                        status: true
                    }
                ],
                data: [
                    {
                        name: '2018/09/04',
                        value: 1083
                    },
                    {
                        name: '2018/09/05',
                        value: 941
                    },
                    {
                        name: '2018/09/06',
                        value: 1139
                    },
                    {
                        name: '2018/09/07',
                        value: 816
                    },
                    {
                        name: '2018/09/08',
                        value: 327
                    },
                    {
                        name: '2018/09/09',
                        value: 228
                    },
                    {
                        name: '2018/09/10',
                        value: 1065
                    }
                ],
                options: {
                    type: 'bar',
                    title: {
                        text: '用户[认证/实名]职业数据展示图'
                    },
                    xRorate: 25,
                    labels: ['仅认证', '已实名'],
                    datasets: [
                        {
                            label: '计调/操作',
                            data: [234, 278]
                        },
                        {
                            label: '销售/客服',
                            data: [164, 178]
                        },
                        {
                            label: '导游/领队',
                            data: [144, 198]
                        },
                        {
                            label: '车队/司机',
                            data: [150, 235]
                        },
                        {
                            label: '酒店/民宿',
                            data: [144, 198]
                        },
                        {
                            label: '旅游定制师',
                            data: [235, 120]
                        },
                        {
                            label: '其他',
                            data: [598, 120]
                        }
                    ]
                },
                options2: {
                    type: 'line',
                    title: {
                        text: '最近几个月营运数据展示图'
                    },
                    labels: ['6月', '7月', '8月', '9月', '10月'],
                    datasets: [
                        {
                            label: '报价行程',
                            data: [234, 278, 270, 190, 230]
                        },
                        {
                            label: '试用会员',
                            data: [164, 178, 150, 135, 160]
                        },
                        {
                            label: '付费会员',
                            data: [74, 118, 200, 235, 90]
                        }
                    ]
                }
            };
        },
        components: {
            Schart
        },
        computed: {
            role() {
                return this.name === 'admin' ? '超级管理员' : '系统管理员';
            }
        },
        created() {
            //     this.handleListener();
            //     this.changeDate();
            this.initUser();
          //  this.initPageData();
        },
        // activated() {
        //     this.handleListener();
        // },
        // deactivated() {
        //     window.removeEventListener('resize', this.renderChart);
        //     bus.$off('collapse', this.handleBus);
        // },
        methods: {
            // 服务器返回数据处理-统计career 数据
            mergeCareerData(dataA, dataB) {
                // 获取所有职业标签的并集
                const allLabels = [...new Set([
                    ...Object.keys(dataA),
                    ...Object.keys(dataB)
                ])];

                // 按特定顺序排序（可选）
                const customOrder = [
                    '计调/操作', '销售/客服', '导游/领队',
                    '车队/司机', '酒店/民宿', '定制师', '其他'
                ];

                const sortedLabels = allLabels.sort((a, b) => {
                    const indexA = customOrder.indexOf(a);
                    const indexB = customOrder.indexOf(b);

                    // 优先按自定义顺序排序
                    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                    if (indexA !== -1) return -1;
                    if (indexB !== -1) return 1;

                    // 不在自定义顺序中的按字母排序
                    return a.localeCompare(b);
                });

                // 构建合并后的数据结构
                return sortedLabels.map(label => ({
                    label,
                    data: [
                        dataA[label] || 0,  // 如果dataA中没有则设为0
                        dataB[label] || 0   // 如果dataB中没有则设为0
                    ]
                }));
            },


            changeDate() {
                const now = new Date().getTime();
                this.data.forEach((item, index) => {
                    const date = new Date(now - (6 - index) * 86400000);
                    item.name = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
                });
            },
            async initUser() {
                const { data: res } = await this.$http.get('/admin/partner/initUser', {
                    params: this.uid
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取数据失败，请联系管理员!');
                }
                this.user = res.user;
                return this.$message.success('initUser数据初始化成功!');
            },
            async initPageData() {
                const { data: dataRes } = await this.$http.get('/admin/member/getIndexUserNum', {
                });
                if (dataRes.code !== 200) {
                    return this.$message.error('系统错误，获取totalUser数据失败，请联系管理员!');
                }
                this.pageData.zanfangqi = dataRes.zanfangqi;
                this.pageData.daikaifa = dataRes.daikaifa;
                this.pageData.yihezuo = dataRes.yihezuo;
                return this.$message.success('initPageData数据初始化成功!');
            }

            // handleListener() {
            //     bus.$on('collapse', this.handleBus);
            //     // 调用renderChart方法对图表进行重新渲染
            //     window.addEventListener('resize', this.renderChart);
            // },
            // handleBus(msg) {
            //     setTimeout(() => {
            //         this.renderChart();
            //     }, 200);
            // },
            // renderChart() {
            //     this.$refs.bar.renderChart();
            //     this.$refs.line.renderChart();
            // }
        }
    };
</script>


<style scoped>
    .el-row {
        margin-bottom: 20px;
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 100px;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
    }

    .grid-con-icon {
        font-size: 50px;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        color: #fff;
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(45, 140, 240);
    }

    .grid-con-1 .grid-num {
        color: rgb(45, 140, 240);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(100, 213, 114);
    }

    .grid-con-2 .grid-num {
        color: rgb(45, 140, 240);
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(242, 94, 67);
    }

    .grid-con-3 .grid-num {
        color: rgb(242, 94, 67);
    }

    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    }

    .user-avator {
        width: 120px;
        height: 120px;
        border-radius: 50%;
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }

    .user-info-list {
        font-size: 14px;
        color: #999;
        line-height: 25px;
    }

    .user-info-list span {
        margin-left: 70px;
    }

    .mgb20 {
        margin-bottom: 20px;
    }

    .todo-item {
        font-size: 14px;
    }

    .todo-item-del {
        text-decoration: line-through;
        color: #999;
    }

    .schart {
        width: 100%;
        height: 300px;
    }
</style>
